/**
 * Collateral Analytics API Service
 *
 * Type-safe endpoints for asset-class distribution and valuation history.
 * Types derived from platform-admin.openapi.yaml -- no manual interfaces.
 *
 * Endpoints:
 *   GET /collateral/distribution-by-asset-class
 *   GET /collateral/valuations
 */

import { platformAdminClient } from '../client';
import type { components } from '@aaimplatform/institutional-types/platform-admin';

export type AssetClassDistributionItem = components['schemas']['AssetClassDistributionItem'];
export type AssetClassDistributionResponse = components['schemas']['AssetClassDistributionResponse'];
export type ValuationRecord = components['schemas']['ValuationRecord'];
export type ValuationListResponse = components['schemas']['ValuationListResponse'];
export type ValuationQueryParams = components['schemas']['ValuationQueryParams'];

export const collateralAnalyticsApi = {
  getDistributionByAssetClass: async (): Promise<AssetClassDistributionResponse> => {
    const { data, error } = await platformAdminClient.GET(
      '/collateral/distribution-by-asset-class',
    );
    if (error) throw new Error('Failed to fetch asset class distribution');
    if (!data) throw new Error('Empty response from asset class distribution endpoint');
    return data;
  },

  listValuations: async (params?: ValuationQueryParams): Promise<ValuationListResponse> => {
    const { data, error } = await platformAdminClient.GET('/collateral/valuations', {
      params: {
        query: {
          positionId: params?.positionId,
          securityId: params?.securityId,
          from: params?.from,
          to: params?.to,
          page: params?.page,
          limit: params?.limit,
        },
      },
    });
    if (error) throw new Error('Failed to fetch valuation history');
    if (!data) throw new Error('Empty response from valuation history endpoint');
    return data;
  },
};
